/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import { RootState } from '../../store';
import { setIdConnection, setToken, setModuleId, setUserId, refreshToken } from '../../store/slices/auth';
import { useSearchParams } from 'react-router-dom';

interface SignalLoaderProps {
    children: React.ReactNode;
}

export const SignalConnectionLoader: React.FC<SignalLoaderProps> = ({ children }) => {
    const dispatch = useDispatch();
    const authState = useSelector((state: RootState) => state.auth);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const token = searchParams.get('token');
        const moduleId = searchParams.get('moduleId');
        const userId = searchParams.get('userId');
        const connectionId = searchParams.get('connectionId');

        if (token && !authState.token) dispatch(setToken(token));
        if (moduleId && !authState.moduleId) dispatch(setModuleId(moduleId));
        if (userId && !authState.userId) dispatch(setUserId(userId));
        if (connectionId && !authState.connectionId) dispatch(setIdConnection(connectionId));
    }, []);

        
    useEffect(() => {
        const token = searchParams.get('token');
        if (authState.token && authState.moduleId && authState.userId && !authState.connectionId) {
            const currentToken = token || authState.token;
            dispatch(refreshToken(currentToken) as any);
        }
    }, [authState.token, authState.moduleId, authState.userId]);

    if (!authState.connectionId) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }
    return <>{children}</>;
};
